import * as React from "react";
import i18n from "i18n";
import {
  Grid,
  Button,
  Typography,
  Card,
  CardHeader,
  CardContent,
  CardActions,
} from "@material-ui/core";
import { Right } from "common/icons";
import { withStyles } from "@material-ui/core/styles";
import bim5d from "common/assets/images/tutorial/bim5d.png";
import criacaoquantitativos from "common/assets/images/tutorial/criacaoquantitativos.png";
import bgCard from "common/assets/images/tutorial/bg.png";

const styles = (theme) => ({
  card: { backgroundColor: "#2E2E2E", width: "571px" },
  cardHeader: {
    backgroundColor: "#3A393E",
    fontSize: "24px",
    padding: "14px",
    textAlign: "center" as any,
    "& span": {
      color: "#9AAF00",
      fontWeight: "700" as any,
      lineHeight: "28px",
      fontFamily: "Roboto",
    },
  },
  cardActions: { backgroundColor: "#3A393E", justifyContent: "flex-end" },
  btnNext: {
    backgroundColor: "#9AAF00",
    color: "#FFFFFF",
    padding: "8px 16px 8px 16px",
    fontSize: "14px",
    transition: ".3s",
    display: "flex",
    flexDirection: "row" as any,
    justifyContent: "center",
    alignItems: "flex-start",
    "&:hover": { backgroundColor: "#697513" },
  },
  txtEng: {
    color: "#9AAF00",
    fontSize: "16px",
    lineHeight: "19px",
    fontWeight: 700,
    paddingRight: "35px",
  },
  txtMeetRubk: {
    color: "#EEEEEE",
    fontSize: "16px",
    lineHeight: "19px",
    fontWeight: 200,
    paddingRight: "35px",
  },
  baseGrid: { display: "flex" as any, flexDirection: "column" as any },
});

const Welcome = (props) => {
  const { classes, handleFirstLogin } = props;

  return (
    <Card className={classes.card}>
      <CardHeader
        title={i18n.trialRegister.welcome.welcomeToRubk}
        className={classes.cardHeader}
      />
      <CardContent
        style={{
          padding: "33px 24px",
          backgroundImage: `url(${bgCard})`,
          backgroundPositionX: "-7px",
          height: "312px",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Grid container direction="row">
          <Grid item xs={6} className={classes.baseGrid}>
            <Typography className={classes.txtEng}>
              {i18n.trialRegister.welcome.engineeringCosts}
            </Typography>
            <Typography
              className={classes.txtMeetRubk}
              style={{ paddingTop: "42px" }}
            >
              {i18n.trialRegister.welcome.meetRubk}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.baseGrid}>
            <img src={bim5d} alt="" />
            <img
              src={criacaoquantitativos}
              alt=""
              style={{ paddingTop: "41px" }}
            />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <Button
          size="small"
          className={classes.btnNext}
          onClick={() => handleFirstLogin()}
        >
          {i18n.trialRegister.welcome.continue}{" "}
          <Right style={{ width: "10px", marginLeft: "5px" }} />
        </Button>
      </CardActions>
    </Card>
  );
};

export default withStyles(styles)(Welcome);



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/Welcome.tsx